import { BaseModule } from './BaseModule';

export class Toolbar extends BaseModule {
    private toolbar: any;
    private alignments: any;

    onCreate = () => {
        // Setup Toolbar
        this.toolbar = document.createElement('div');
        Object.assign(this.toolbar.style, this.options.toolbarStyles);
        this.overlay.appendChild(this.toolbar);

        // Setup Buttons
        this._defineAlignments();
        this._addToolbarButtons();
    };

    // The toolbar and its children will be destroyed when the overlay is removed
    onDestroy = () => { };

    // Nothing to update on drag because we are are positioned relative to the overlay
    onUpdate = () => { };

    _defineAlignments = () => {
        this.alignments = [
            {
                icon: '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line></svg>',
                apply: () => { this.img.setAttribute('class', "ql-img-left"); },
                isApplied: () => this.img.getAttribute('class') == "ql-img-left"
            },
            {
                icon: '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"></line><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"></line></svg>',
                apply: () => { this.img.setAttribute('class', "ql-img-center"); },
                isApplied: () => this.img.getAttribute('class') == "ql-img-center"
            },
            {
                icon: '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"></line><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"></line></svg>',
                apply: () => { this.img.setAttribute('class', "ql-img-right"); },
                isApplied: () => this.img.getAttribute('class') == "ql-img-right"
            },
        ];
    };

    _addToolbarButtons = () => {
        const buttons: Array<any> = [];
        this.alignments.forEach((alignment: any, idx: number) => {
            const button: any = document.createElement('span');
            buttons.push(button);
            button.innerHTML = alignment.icon;
            button.addEventListener('click', () => {
                // deselect all buttons
                buttons.forEach(button => button.style.filter = '');
                if (alignment.isApplied()) {
                    // If applied, unapply
                    this.img.setAttribute('class', "");
                } else {
                    // otherwise, select button and apply
                    this._selectButton(button);
                    alignment.apply();
                }
                // image may change position; redraw drag handles
                this.requestUpdate();
            });
            Object.assign(button.style, this.options.toolbarButtonStyles);
            if (idx > 0) {
                button.style.borderLeftWidth = '0';
            }
            if (button.children.length > 0) {
                Object.assign(button.children[0].style, this.options.toolbarButtonSvgStyles);
            }
            if (alignment.isApplied()) {
                // select button if previously applied
                this._selectButton(button);
            }
            this.toolbar.appendChild(button);
        });
    };

    _selectButton = (button: any) => {
        button.style.filter = 'invert(20%)';
    };

}
